import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  wrapHeader:{
    "& img": {
      transition: "all 0.2s ease-in-out",
    },
    "& img:hover": {
      cursor: "pointer",
      opacity: "0.9",
      transition: "all 0.2s ease-in-out"
    }
  },
  img: {
    filter: "brightness(55%)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    width: "100%",
    height: 300,
  },

  large: {
    width: 80,
    height: 80,
    border: "2px solid #5675D3",
  },
  wrapHeaderToko: {
    display: "flex",
    margin: "0",
    position: "absolute",
    top: "210px",
    left: "50%",
    msTransform: "translate(-50%, -50%)",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    borderRadius: 5,
  },
  wrapAvatar: {
    display: "flex",
    alignItems: "center",
    "& label:hover": {
      cursor: "pointer"
    }
  },
  wrapDetail: {
    marginLeft: "20px",
  },
  liquidRow: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "flex-start",
    width: "100%",
  },
  liquidTitle:{
    color: theme.palette.textColor.black,
  },
  liquidButton:{
    color: theme.palette.textColor.black,
    fontSize: 12,
  },
  liquidLabel: {
    color: theme.palette.textColor.black,
    width: 150,
    marginRight: 10,
    fontSize: 14,
  },
  liquidValue: {
    color: theme.palette.textColor.black,
    fontSize: 13,
    width: "75%",
    wordBreak: "break-all",
  },
  
  fab: {
    marginLeft: theme.spacing(2),
  },
  fab1: {
    display: "flex",
    position: "fixed",
    bottom: "60px",
    right: "15px",
  },
 btnHeader:{
   cursor:"pointer",
   textAlign:"center",
   paddingBottom:10,
   "&:hover":{
     backgroundColor:"#F0F0F0",
     borderRadius:10
   }
 }
}));

export default useStyles;
